// arabicKeyMap.ts
export const ARABIC_KEY_MAP: Record<string, string> = {
  // ---------- VOWELS ----------
  a: "ا",
  A: "آ",
  i: "ي",
  I: "إ",
  u: "و",
  U: "ؤ",
  e: "ي",
  o: "و",

  // ---------- BASIC CONSONANTS ----------
  b: "ب",
  t: "ت",
  j: "ج",
  H: "ح",
  d: "د",
  r: "ر",
  z: "ز",
  s: "س",
  S: "ص",
  f: "ف",
  q: "ق",
  k: "ك",
  l: "ل",
  m: "م",
  n: "ن",
  h: "ه",
  w: "و",
  y: "ي",

  // ---------- EMPHATIC / SHIFT ----------
  D: "ض",
  T: "ط",
  Z: "ظ",
  G: "غ",
  K: "خ",
  C: "ع",
  X: "خ",

  // ---------- HAMZA / ALEF ----------
  "'": "ء",
  "`": "ئ",
  "{": "أ",
  "}": "إ",

  // ---------- SPECIAL ----------
  p: "ة",
  v: "ث",
  g: "ج",
  x: "ش",
  c: "ك",

  // ---------- NUMBERS ----------
  "0": "٠",
  "1": "١",
  "2": "٢",
  "3": "٣",
  "4": "٤",
  "5": "٥",
  "6": "٦",
  "7": "٧",
  "8": "٨",
  "9": "٩",

  // ---------- PUNCTUATION ----------
  ",": "،",
  ";": "؛",
  "?": "؟",
  ".": "۔",
  "/": "؟",
};